import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Mirko3Service } from '../mirko3.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { SicotService } from '../sicot.service';
import { User } from '../types/User';

@Component({
  selector: 'app-attivita',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatButtonModule, CommonModule, MatDatepickerModule, MatProgressBarModule, MatPaginatorModule, MatIconModule],
  templateUrl: './attivita.component.html',
  styleUrl: './attivita.component.css',
  providers: [provideNativeDateAdapter()]
})
export class AttivitaComponent implements AfterViewInit{


  @Output() attivitaId = new EventEmitter<any[]>();

  @Input() attivitaIntervento: any[] = [];

  ngAfterViewInit() {
    if (this.dataSource)
    this.dataSource.paginator = this.paginator;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);


  selectedAttivita: any[] = [];
  attivita: Attivita[] = [];
  loadinDisponibilitaUVM: boolean = false;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;

  displayedColumns: string[] = ['descrizione', 'action'];
  displayedColumnsDisponibilitaSessioneUVM: string[] = ['data', 'oraInizio', 'oraFine', 'struttura', 'StruttureBreve', 'action2'];
  dataSource: any;
  dataSoruceSelected: any;
  dataSoruceDisponibilitaSessioneUVM: any;


  get mostraFiltroDisponibilita() {
    return this.filtroDisponibilita;
  }

  get mostraSceltaDisponibilita() {
    return this.sceltaDisponibilita;
  }

  get mostraCaricamentoDisponibilitaUVM() {
    return this.loadinDisponibilitaUVM;
  }

  constructor(private siCotService: SicotService) {

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    console.log("Dati ricevuti in attivitaIntervento:", this.attivitaIntervento)
    this.fetchAttivita();


  }





  back() {
    this.sceltaDisponibilita = false;
    this.filtroDisponibilita = true;
  }

  fetchAttivita(): void {
    this.siCotService.getAttivita().subscribe(
      (data) => {
        this.attivita = data;
        this.dataSource = new MatTableDataSource<Attivita[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.error('Error fetching attivita:', error);
      }
    );


    const codici = this.attivitaIntervento.map(attivita => attivita.codice); 
    console.log("Codici attivita:", codici);
  
 
      this.siCotService.getAttivitaByCodice(codici).subscribe(
        (data : String[]) => {
          data.forEach((el) => {
            this.addToSelected(el);
          });
        },        
        (error) => {
          console.error(`Error fetching attivita for codice ${codici}:`, error);
        }
      );
    
  }

  addToSelected(item: any): void {
    
    this.selectedAttivita.push(item);
    console.log(this.selectedAttivita)
    this.dataSoruceSelected = new MatTableDataSource<Attivita[]>(this.selectedAttivita);
  }

  svuotaListaAttivita() {
    this.selectedAttivita = [];
    this.dataSoruceSelected = new MatTableDataSource<Attivita[]>(this.selectedAttivita);
  }

  rimuoviDaListaAttivitaSelezionate(item: any) {
    console.log(item);
    if (item) {
      const index = this.dataSoruceSelected.data.indexOf(item);
      if (index > -1) {
        this.dataSoruceSelected.data.splice(index, 1);
        this.dataSoruceSelected = new MatTableDataSource(this.dataSoruceSelected.data);
      }
    }
  }

  saveAttivita(){
    this.attivitaId.emit(this.selectedAttivita)
  }
}


export interface Attivita {
  id: number;
  codice: string;
  descrizione: string;
}








